import React from "react"
import styled from "styled-components"
import {useHistory} from 'react-router-dom'

const StyledLink = styled.div`
  height: 50px;
  padding: 5px 15px;
  box-sizing: border-box;
  color: #233467;
  transition: 0.3s;
  text-transform: uppercase;
  font-weight: bold;
  border-bottom: 2px solid #fff;
  display: flex;
  align-items: center;
  
  :hover {
    background-color: #204051;
    cursor: pointer;
    border-bottom: 2px solid #233467;
    color: #fff;
  }
`

const Link = ({content = "", link = "/"}) => {
    const history = useHistory()
    return <StyledLink onClick={() => history.push(link)}>{content}</StyledLink>
}

export default Link
